import { Button, styled } from "@mui/material";

/* TODO: frosted class unification */
export const OverlayControlWrapper = styled("div")(
  () => `
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 10px;
  top: 10px;
  max-height: calc(100cqh - 88px);
  overflow-x: hidden;
  overflow-y: auto;
  max-width: calc(100cqw - 20px);
  scrollbar-width: none;
  z-index: 4000001;

  &::-webkit-scrollbar {
    display: none;
  }
`,
);

export const OverlayControl = styled("div")<{
  expanded: boolean;
}>(
  ({ expanded = false }) => `
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: calc(100cqh - 88px);
  transition: width .2s ease;
  width: ${
    expanded
      ? "calc(100cqw - 20px)"
      : "clamp(calc(50cqw - 48px), 400px, calc(100cqw - 20px))"
  };
`,
);

export const OverlayControlToggle = styled(Button)(`
  align-items: center;
  color: black;
  display: flex;
  gap: 8px;
  text-transform: none;
`);

export const OverlayControlHeader = styled("div")<{ transparent?: boolean }>(
  ({ transparent = true }) => `
  align-items: flex-start;
  background-color: ${transparent ? "transparent" : "white"};
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: space-between;
  padding: 6px 12px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;

  svg {
    cursor: pointer;
  }
`,
);

export const OverlayControlDisplayToggle = styled("div")`
  background: white;
  display: flex;
  justify-content: space-around;
  padding-bottom: 4px;
`;

export const OverlayControlDisplayButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>(
  ({ active }) => `
  color: ${active ? "red" : "black"};
`,
);

export const OverlayControlContent = styled("div")`
  background: white;
  max-height: 100%;
  overflow-x: auto;
`;
